import AppLayout from "@/layouts/AppLayout";
import PeopleTabs from "./_components/PeopleTabs";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  return (
    <AppLayout>
      <PeopleTabs />
      <div className="flex flex-col">{children}</div>
    </AppLayout>
  );
}
